import styled from "styled-components";

const Grid = styled.div`
    background: rgb(249, 241, 221);
    display: grid;
    grid-template-areas:
        "header"
        "title"
        "main";
    grid-template-rows: 100px auto;
    margin: 0;
    font-family: "TT Commons Pro", sans-serif;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    @media (max-width: 780px) {
        grid-template-rows: 70px auto;
    }
    @media (max-width: 1240px) {
        grid-template-rows: 50px auto;
    }
`;

export default Grid;
